import { Injectable, OnInit, ViewContainerRef } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { v_EmployeeSearchBus } from '../models/v_EmployeeSearchBus';
import { DQOISearchParam } from '../models/DQOISearchParam';
import { BehaviorSubject } from 'rxjs';
import { GItem } from '../models/GItem';
import { DQOISearchEvent } from '../models/DQOISearchEvent';
import { SearchTarget } from '../enums/SearchTarget';
import { ToolbarEvent } from '../enums/ToolbarEvent';
import { DQOIToolbarEvent } from '../models/DQOIToolbarEvent';
import { DispatchesService } from './dispatches.service';
import { DQOIState } from '../models/DQOIState';
import { DQOIReferenceData } from '../models/DQOIReferenceData';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { GlobalsService } from './globals.service';
import { DQOIItem } from '../models/DQOIItem';
import { CommonFunctions } from '../static/common-functions';
import { CommonValues } from '../static/CommonValues';
import { CommonParam } from '../models/CommonParam';
import { DispatchPartsRequestedBus } from '../models/DispatchPartsRequestedBus';
import { DispatchSaveParam } from '../models/DispatchSaveParam';
import { Message } from '../models/message';
import { cleanSession } from 'selenium-webdriver/safari';
import { MessageType } from '../enums/MessageType';
import { DispatchData } from '../models/DispatchData';
import { DbTable } from '../enums/DbTable';
import { AssignablePersonBus } from '../models/AssignablePersonBus';
import { QIParam } from '../models/QIParam';
import { QuickSearch } from '../models/QuickSearch';

@Injectable()
export class DQOIService extends BaseService {

    constructor(_http: HttpClient, private svc_dispatch: DispatchesService) {
        super(_http);
        this.baseUrl = this.rootUrl + "Search/";
        this.baseUrlCustomer = this.rootUrl + "Customer/";
        this.baseUrlQuote = this.rootUrl + "Quote/";
        this.baseUrlDispatch = this.rootUrl + "Dispatch/";
        this.baseUrlOrder = this.rootUrl + "Order/";
        this.baseUrlInvoice = this.rootUrl + "Invoice/";
        this.baseUrlConstruction = this.rootUrl + "Construction/";
        this.baseUrlInventory = this.rootUrl + "Inventory/";
        this.baseUrlAuthentication = this.rootUrl + "Authentication/";
    }
    baseUrlCustomer: string;
    baseUrlQuote: string;
    baseUrlDispatch: string;
    baseUrlOrder: string;
    baseUrlInvoice: string;
    baseUrlConstruction: string;
    baseUrlInventory: string;
    baseUrlAuthentication: string;

    private _dqoiItems: DQOIItem[] = [];
    private _searchEvent: BehaviorSubject<DQOISearchEvent> = new BehaviorSubject(null);
    private _toolbarEvent: BehaviorSubject<DQOIToolbarEvent> = new BehaviorSubject(null);
    private _customerIdSubject: BehaviorSubject<any> = new BehaviorSubject(null);
    private _locationIdSubject: BehaviorSubject<any> = new BehaviorSubject(null);
    private _dqoiState: BehaviorSubject<DQOIState> = new BehaviorSubject(new DQOIState());
    private _message: BehaviorSubject<Message> = new BehaviorSubject(null);
    public customerId$: Observable<any> = this._customerIdSubject.asObservable();
    public locationId$: Observable<any> = this._locationIdSubject.asObservable();
    public searchEvent$: Observable<DQOISearchEvent> = this._searchEvent.asObservable();
    public toolbarEvent$: Observable<DQOIToolbarEvent> = this._toolbarEvent.asObservable();
    public dqoiState$: Observable<DQOIState> = this._dqoiState.asObservable();
    public referenceData: DQOIReferenceData = null; // = this._referenceData.value;
    public message$: Observable<Message> = this._message.asObservable();
    private quickSearchAnchor = new BehaviorSubject<ViewContainerRef>(null);
    quickSearchAnchor$ = this.quickSearchAnchor.asObservable();

    about(): Observable<any> {
        let url_call: string = this.baseUrlAuthentication + "About";
        return super.get(url_call);
    }
    dropQuickSearchAnchor(anchor: ViewContainerRef) {
        this.quickSearchAnchor.next(anchor);
    }
    dqoi_QuickSearch(param: DQOISearchParam): Observable<any> {
        let s_param: string = JSON.stringify(param);
        let options = this.getOptionsU(param.userId, "DQOISearchParam", s_param);
        let url_call: string = this.rootUrl + "QuickSearch/DQOI_QuickSearch";
        return this._http.get(url_call, options);
    }
    dispatch_search(param: DQOISearchParam): Observable<any> {
        const quickSearch = {} as QuickSearch;
        quickSearch.search = param.search;
        quickSearch.searchType = param.isOpen ? 0 : 1;
        var data = JSON.stringify(quickSearch);
        let url_call: string = this.rootUrl_v2 + `search/dispatch`;
        return super.post(url_call, data);
    }
    quote_search(param: DQOISearchParam): Observable<any> {
        const quickSearch = {} as QuickSearch;
        quickSearch.search = param.search;
        quickSearch.searchType = param.isOpen ? 0 : 1;
        var data = JSON.stringify(quickSearch);
        let url_call: string = this.rootUrl_v2 + `search/quote`;
        return super.post(url_call, data);
    }
    order_search(param: DQOISearchParam): Observable<any> {
        const quickSearch = {} as QuickSearch;
        quickSearch.search = param.search;
        quickSearch.searchType = param.isOpen ? 0 : 1;
        var data = JSON.stringify(quickSearch);
        let url_call: string = this.rootUrl_v2 + `search/order`;
        return super.post(url_call, data);
    }
    invoice_search(param: DQOISearchParam): Observable<any> {
        const quickSearch = {} as QuickSearch;
        quickSearch.search = param.search;
        quickSearch.searchType = param.isOpen ? 0 : 1;
        var data = JSON.stringify(quickSearch);
        let url_call: string = this.rootUrl_v2 + `search/invoice`;
        return super.post(url_call, data);
    }
    createNewQuoteFromDispatch(id: any): Observable<any> {
        let url_call: string = this.baseUrlQuote + "CreateNewFromDispatch/" + id;
        return super.get(url_call);
    }
    createNewQuoteFromInvoice(id: any): Observable<any> {
        let url_call: string = this.baseUrlQuote + "CreateNewFromInvoice/" + id;
        return super.get(url_call);
    }
    createNewDispatchFromQuote(id: any): Observable<any> {
        let url_call: string = this.baseUrlDispatch + "CreateNewDispatchFromQuote/" + id;
        return super.get(url_call);
    }
    createNewDispatchFromInvoice(id: any): Observable<any> {
        let url_call: string = this.baseUrlDispatch + "CreateNewDispatchFromInvoice/" + id;
        return super.get(url_call);
    }
    createNewInvoiceFrom(from: SearchTarget, id: any): Observable<any> {
        let url_call: string = this.baseUrlInvoice + "CreateInvoiceFrom/" + from + "/" + id;
        return super.get(url_call);
    }
    createNewFromDispatchPartsReq(model: DispatchSaveParam): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrlOrder + "CreateNewFromDispatchPartsReq";
        return this._http.put(url_call, model, { headers });
    }
    //createNewFromDispatchPartsReq(parts: DispatchPartsRequestedBus[]): Observable<any> {
    //    let seParam: CommonParam = new CommonParam();
    //    seParam.addParam("PARTS", parts);
    //    let commonParam = JSON.stringify(seParam);
    //    let options = this.getOptionsUL('', '', "commonParam", commonParam);
    //    let url_call: string = this.baseUrlOrder + "CreateNewFromDispatchPartsReq";
    //    return this._http.get(url_call, options);
    //}
    createNewOrderFromDispatch(id: any): Observable<any> {
        let url_call: string = this.baseUrlOrder + "CreateNewFromDispatch/" + id;
        return super.get(url_call);
    }
    createNewOrderFromQuote(id: any): Observable<any> {
        let url_call: string = this.baseUrlOrder + "CreateNewFromQuote/" + id;
        return super.get(url_call);
    }
    createNewOrderFromJob(id: any, isSub: boolean): Observable<any> {
        let url_call: string = this.baseUrlOrder + "CreateNewFromJob/" + id + "/" + (isSub ? "true" : "false");
        return super.get(url_call);
    }

    customer_Search(search: string): Observable<any> {
        let url_call: string = this.baseUrl + "Customer_Search/" + search;
        return super.get(url_call);
        //return this._http.get(url_call);
    }

    potentialCustomer_Search(search: string): Observable<any> {
        let url_call: string = this.baseUrl + "PotentialCustomer_Search/" + search;
        return super.get(url_call);
        //return this._http.get(url_call);
    }
    person_Search(model: any): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(model);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "Person_Search";

        return this._http.get(url_call, options);
    }
    generic_Search(model: any): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(model);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "Generic_Search";

        return this._http.get(url_call, options);
    }

    searchCustomerLocations(param: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "SearchCustomerLocations";
        return this._http.get(url_call, options);
    }
    dqoiSearch(param: DQOISearchParam): Observable<any> {
        let s_param: string = JSON.stringify(param);
        let options = this.getOptionsU(param.userId, "DQOISearchParam", s_param);

        let url_call: string;
        switch (param.searchTarget) {
            case SearchTarget.dispatch:
                url_call = this.baseUrl + "DQOISearch_Dispatch";
                break;
            case SearchTarget.invoice:
                url_call = this.baseUrl + "DQOISearch_Invoices";
                break;
            case SearchTarget.quote:
                url_call = this.baseUrl + "DQOISearch_Quotes";
                break;
            case SearchTarget.order:
                url_call = this.baseUrl + "DQOISearch_Orders";
                break;
        }
        return this._http.get(url_call, options);
    }
    dqoiSearch_Dispatch(param: DQOISearchParam): Observable<any> {
        let s_param: string = JSON.stringify(param);
        let options = this.getOptionsU(param.userId, "DQOISearchParam", s_param);
        let url_call: string = this.baseUrl + "DQOISearch_Dispatch";
        return this._http.get(url_call, options);
    }
    getCustomerFromName(name: string): Observable<any> {
        let cParam: CommonParam = new CommonParam();
        cParam.search = name;
        let commonParam = JSON.stringify(cParam);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetCustomerFromName/" + name;
        return this._http.get(url_call, options);
    }
    getPotentialCustomerFromName(name: string): Observable<any> {
        let cParam: CommonParam = new CommonParam();
        cParam.search = name;
        let commonParam = JSON.stringify(cParam);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        let url_call: string = this.baseUrl + "GetPotentialCustomerFromName/" + name;
        return this._http.get(url_call, options);
    }
    GetPotentialCustomerFromName;
    getLocationDetail(id: string): Observable<any> {
        let url_call: string = this.baseUrlCustomer + "GetLocationDetail/" + id;
        return super.get(url_call);
    }
    getLocationDetailAsDefaults(id: string): Observable<any> {
        let url_call: string = this.baseUrlCustomer + "GetLocationDetailAsDefaults/" + id;
        return super.get(url_call);
    }
    customerIdChanged(id: any) {
        this._customerIdSubject.next(id);
    }
    locationIdChanged(id: any) {
        this._locationIdSubject.next(id);
    }
    nextSearchEvent(event: DQOISearchEvent) {
        this._searchEvent.next(event);
    }
    nextToolbarEvent(event: DQOIToolbarEvent) {
        this._toolbarEvent.next(event);
    }
    nextDQOIState(data: DQOIState) {
        this._dqoiState.next(data);
    }
    getDQOIState(): DQOIState {
        return this._dqoiState.getValue();
    }
    hasDQOIItems(): boolean {
        return (CommonFunctions.hasArrayValue(this._dqoiItems) && this._dqoiItems.length > 0) ? true : false;
    }
    addDQOIItem(data: DQOIItem): DQOIItem {
        data.index = this.getMaxDQOIIndex() + 1;
        this.setDQOIItem(data);
        return data;
    }
    getMaxDQOIIndex() {
        let maxValue: number = 0;
        if (this.hasDQOIItems()) {
            maxValue = Math.max(...this._dqoiItems.map(o => o ? o.index : 0), 0);
        }
        return maxValue;
    }
    showDQOIItems() {
    }
    clearDQOIItems() {
        this._dqoiItems = [];
    }
    clearDQOIItem(index: number) {
        if (this.hasDQOIItems()) {
            let indexToRemove: number = -1;
            for (let i = 0; i < this._dqoiItems.length; i++) {
                if (this._dqoiItems[i] !== null && index === this._dqoiItems[i].index) {
                    indexToRemove = i;
                    break;
                }
            }
            if (indexToRemove >= 0) {
                this._dqoiItems.splice(indexToRemove, 1);
            }
        }
    }
    getDQOIItem(index: number): DQOIItem {
        let item: DQOIItem = null;
        let data: DQOIItem = null;
        if (this.hasDQOIItems()) {
            item = this._dqoiItems.find(x => x !== null && x.index === index);
            if (item) {
                data = new DQOIItem(item);
            }
        }
        return data;
    }

    setDQOIItem(data: DQOIItem) {
        let item: DQOIItem = this.getDQOIItem(data.index);
        if (CommonFunctions.hasValue(item)) {
            for (let i = 0; i < this._dqoiItems.length; i++) {
                if (this._dqoiItems[i] !== null && item.index === this._dqoiItems[i].index) {
                    this._dqoiItems[i] = data;
                }
            }
        }
        else {
            this._dqoiItems.push(data);
        }
    }
    getReferenceDataUpdateDate(): Observable<any> {
        return this.svc_dispatch.getReferenceDataUpdateDate();
    }
    getReferenceData(companyId: string): Observable<any> {
        return this.svc_dispatch.GetReferenceData(companyId);
    }
    dispatchTypes: GItem[] = [
        //    { "description": "", "value":"", "category":"" },
        { "description": "All Dispatches & Jobs", "value": "A", "category": "", "reference": null },
        { "description": "Service Dispatches Only", "value": "S", "category": "", "reference": null },
        { "description": "Construction Dispatches Only", "value": "C", "category": "", "reference": null }
    ];
    searchOptions: GItem[] = [
        { "description": "Note Text", "value": "D", "category": "", "reference": null },
        { "description": "Quote #", "value": "Q", "category": "", "reference": null },
        { "description": "Order #", "value": "O", "category": "", "reference": null },
        { "description": "Invoice #", "value": "I", "category": "", "reference": null }
    ];
    getDQOITemFromDb(id: string): Observable<any> {
        return this.svc_dispatch.getDQOIItem(id);
    }
    getDQOITemConstFromDb(id: string): Observable<any> {
        let url_call: string = this.baseUrlConstruction + "GetDQOIItem/" + id;
        return super.get(url_call);
    }
    canCreate(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrlDispatch + "CanCreate";
        return this._http.put(url_call, model, { headers });
    }
    getInventoryLine(model: CommonParam): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrlInvoice + "GetInventoryLine";
        return this._http.put(url_call, model, { headers });
    }
    getItemSelected(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrlInventory + "GetItemSelected";
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    recalculateAfterTaxCode(param: QIParam): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrlInvoice + "RecalculateAfterTaxCode";
        return this._http.put(url_call, param, { headers });
    }

    cnst_QuickSearch(param: DQOISearchParam): Observable<any> {
        let s_param: string = JSON.stringify(param);
        let options = this.getOptionsU(param.userId, "DQOISearchParam", s_param);
        let url_call: string = this.rootUrl + "QuickSearch/Cnst_QuickSearch";

        return this._http.get(url_call, options);
    }

    sendMessage(message: Message) {
        this._message.next(message);
    }
    getMessage(clear: boolean = false) {
        this._message.getValue();
        if (clear) {
            this.sendMessage(null);
        }
    }
    showDQOI(id: any, target: SearchTarget = SearchTarget.dispatch) {
        let data: DispatchData = new DispatchData();
        data.viewDispatch.dispatchId = id;
        let msg: Message = new Message();
        msg.messageType = MessageType.dqoiPopup;
        msg.value = data;
        this.sendMessage(msg);
    }
    refreshDQOI(target: SearchTarget = SearchTarget.any) {
        let msg: Message = new Message();
        msg.messageType = MessageType.refresh;
        msg.value = target;
        this.sendMessage(msg);
    }
    getAssignableTech(id: any): any {
        let url_call: string = this.baseUrlDispatch + "GetAssignableTech/" + id;
        return super.get(url_call);

    }
    createDrawWithHeaderOnly(id: any, jId?: any): Observable<any> {
        let url_call: string = this.baseUrlConstruction + "CreateDrawWithHeaderOnly/" + id;
        if (jId) {
            url_call = url_call + "/" + jId;
        }
        return super.get(url_call);
    }
    getDispatchStatus(id: any): any {
        let url_call: string = this.baseUrlDispatch + "GetDispatchStatus/" + id;
        return super.get(url_call);

    }
    getSetPartPrice(param: CommonParam): Observable<any> {
        let url_call: string = this.baseUrlInvoice + "GetSetPartPrice";
        let headers = this.getHeaders();
        let commonParam = JSON.stringify(param);
        let options = this.getOptionsUL('', '', "commonParam", commonParam);
        return this._http.get(url_call, options);
    }
    canSelectAvalarST(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrlDispatch + "CanSelectAvalarST";
        return this._http.post(url_call, model, { headers });
    }

}
